<div [class]="skinName">
  @if (showChangePlan && plansLength) {
    <div id="change-plan-step">
      @if (userSelectedPlan?.amount) {
        <div id="plan-detail" [ngClass]="{'display-flex': plansLength > 1 }">
          <div [ngClass]="(plansLength > 1) ? 'multi-plan-column' : 'single-plan-column' ">
            <div id="plan-title"> {{userSelectedPlan?.title}} </div>
            <div id="plan-amount">
              @if (showDiscountAmount) {
                <span class="disc-amount"> {{userSelectedPlan?.payable_amount }}&nbsp;<span>{{userSelectedPlan?.amount}}</span></span>
              } @else {
                <span class="amount">{{userSelectedPlan?.amount}}</span>
              }
            </div>
          </div>
          @if (plansLength === 1) {
            <div class="plan-text"> {{planService.planText}} </div>
          }
          @if (plansLength > 1) {
            <div class="change-plan-link"><a (click)="changeBtnNavigate()">{{ configService.localeKeys?.change_title}}</a></div>
          }
        </div>
      }
    </div>
  }
  @if (showBackArrow) {
    <div class="special-back-btn">
      <img (click)="mobileNavigate()" class="cursor-pointer" src="branding/theme/assets/static_assets/ic-back-on-lbg.svg">
    </div>
  }
  @if ((!showChangePlan && !operatorPage && !hideSteps)) {
    <div id="signup-step">
      <img (click)="mobileNavigate()" class="cursor-pointer" id="index-back" src="branding/theme/assets/static_assets/ic-back-on-lbg.svg">
      @if (currentStep) {
        <span>{{ configService.localeKeys?.['plans_listing.step.text'] }} {{currentStep}} {{ configService.localeKeys?.['plans_listing.of.text'] }} {{totalStep}}</span>
      }
    </div>
  }
</div>